import { createFileRoute } from '@tanstack/react-router';

import { NotificationsPage, pushSettingsQueryOptions } from '@/features/push-notifications';

/** Every signed-in member manages push on their own devices; no permission gate. */
export const Route = createFileRoute('/_authed/_active/account/notifications')({
  staticData: { crumb: 'push:page.crumb' },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...pushSettingsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: NotificationsPage,
});
